import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

function UserWithdrawModal(props) {
  // Initialize state with default values for accountName, accountNo, and status
  const id = props.id;
  const type = props.type;
  const [amount, setAmount] = useState(props?.amount);
  const [currency, setCurrency] = useState(props?.currency);
  // Handler functions for updating account information
  const isLoading = props.isLoading;
  const handleSubmit = (event) => {
    event.preventDefault();
    let curr = currency;
    if(amount == null || amount == '' || curr == null || curr == ''){
      toast.error('Please Fill all fields');
      return;
    }
    
    let data = {
      unit_amount: amount,
      currency: curr,
      user_id: id,
    };
    // console.log('handleSubmit', data)
    props.onSubmit(data);
  };

  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
  };

  return (
    <Modal isOpen={true} toggle={props.onClose}>
      <ModalHeader toggle={props.onClose}>
        Withdraw From {type} 
      </ModalHeader>
      <ModalBody>
        <Form>
        <FormGroup>
              <Label for="status">Choose Currency</Label>
              <Input
                type="select"
                name="currency"
                id="currnecy"
                onChange={handleCurrencyChange}
                value={currency}
              >
                <option value="">Choose</option>
                {type == "USER" && (
                  <>
                   <option value="MMK">MMK</option>
                   <option value="THB">Bath</option>
                  </>
                )}

                {type == "RESELLER" && (
                  <>
                   <option value="SmileCoin">SmileCoin</option>
                   <option value="AKH-Coin">AKH-Coin</option>
                  </>
                )}
               
              </Input>
            </FormGroup>
          <FormGroup>
            <Label for="title">Amount</Label>
            <Input
              type="text"
              name="title"
              id="title"
              value={amount}
              onChange={handleAmountChange}
            />
          </FormGroup>
          
        </Form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-default" onClick={props.onClose}>
          No
        </button>
        {isLoading == false && (
          <button className="btn btn-success" onClick={handleSubmit}>
            Save
          </button>
        )}
        {isLoading == true && (
          <button className="btn btn-success" disabled="disabled">
            Uploading...
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default UserWithdrawModal;
